<template>
	<div class="w-full h-full flex items-center gap-8">
		<div class="w-full h-full flex items-center gap-1">
			<button
				class="btn btn-tool"
				@click="$emit('search', newSearch)"
			>
				<i class="fal fa-search mx-2 font-20"></i>
			</button>
			<SearchInput
				class="w-full h-full"
				:search="search"
				:placeholder="placeholder"
				:delayed-callback="delayedCallback"
				:custom-classes="customClasses"
				@change="Change"
				@search="$emit('search', newSearch)"
			/>
		</div>
		<div
			v-if="$listeners.refresh"
			class="flex items-center py-1"
		>
			<button
				class="btn btn-tool"
				@click="$emit('refresh')"
			>
				<i class="fal fa-sync mx-2 font-20"></i>
			</button>
		</div>
	</div>
</template>

<script>
	import SearchInput from './SearchInput.vue'

	export default {
		name: 'SearchGroup',
		components: {
			SearchInput,
		},
		props: {
			search: {
				type: String,
				required: true,
			},
			reactiveSearch: {
				type: Boolean,
				default: false,
			},
			delayedCallback: {
				type: Function,
				default: () => {},
			},
			placeholder: {
				type: String,
				default: 'BUSCAR...',
			},
			customClasses: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				newSearch: this.search,
			}
		},
		methods: {
			Change(newSearch) {
				this.newSearch = newSearch
				this.$emit('change', newSearch)
			},
		},
	}
</script>

<style lang="scss" scoped></style>
